import * as api from '../api';

export default (store) => (next) => (action) => {
    const { request, actions, ...rest } = action;

    if (!request) {
        return next(action);
    }

    const requestName = request.toLowerCase().replace(/_([a-z])/g, function (g) { return g[1].toUpperCase(); });

    if (!api[requestName]) {
        return next(action);
    }

    next(action);

    const promise = api[requestName](rest);

    return promise().then(result => {
        next(actions.success({result}));
    }).catch(error => {
        next(actions.error({error, response: error.response, body: error.body}));
    });

};
